import Tooltip from '@material-ui/core/Tooltip';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles as styles } from '../../core/style/gstheme';
import withGS from '../../core/withGShoc';
import GS from '../../grafsync/grafsync';
import LabelIcon from '@material-ui/icons/Label';
import { getNewTabLink } from '../../core/utils/utils';
import { STATUS_REJECTED } from '../../core/utils/constants';

const REJECTED = STATUS_REJECTED;

const loadOptions = {};

class LabelLink extends React.Component {

    handleDeleteLink() {
        // We do this directly to ensure direction of link delete is correct 
        GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.target, null, null, this.props.propertyGraph);
    }

    // We allow a click function or a link
    handleClick = (event) => {
        if (this.props.onClick) {
            this.props.onClick();
        }
        else {
            if (this.props.link && event.ctrlKey) {
                getNewTabLink(this.props.link);
                return;
            }
            this.props.history.push(this.props.link);
            if (this.props.onLink) this.props.onLink();
        }
    };

    render() {

        const { data, classes, defaultLang, isReadOnly, compact, useWorkflow } = this.props;
        const labelLang = Object.keys(data.literalForm) ? Object.keys(data.literalForm)[0] : defaultLang;
        const isLongLang = labelLang.length > 2;
        const style = isLongLang ? { width: '40px', borderRadius: '16px', backgroundColor: '#01579B' } : { backgroundColor: '#01579B' };
        const isRejected = useWorkflow && "status" in data && data.status[0] === REJECTED ? true : false;

        const currentId = data.iri && data.iri.length > 0 ?
            data.iri[data.iri.length - 1]
            :
            data.id;

        return (
            <Tooltip
                PopperProps={{
                    "data-test": "chip-tip"
                }}
                title={currentId}>
                <Chip color="primary"
                    className={compact ? classes.compactChip : classes.chip}
                    avatar={<Avatar style={style}>{labelLang}</Avatar>}
                    data-status={
                        data.pendingDeletion === true ?
                            "deleted"
                            :
                            null
                    }
                    onClick={this.handleClick}
                    style={
                        {
                            ...(data.pendingDeletion === true || isRejected) && { backgroundColor: '#DD2C00' }
                        }
                    }
                    onDelete={!isReadOnly ? (() => this.handleDeleteLink()) : null}
                    label={<span data-test="chip-text">
                        {
                            <span style={{
                                display: 'inline-block',
                                transform: 'translateY(2px)'
                            }}>
                                <LabelIcon fontSize="small" />
                            </span>
                        }
                        <span data-test="chip-label" style={{
                            display: 'inline-block',
                            transform: 'translateY(-4px)',
                            paddingTop: '5px',
                            paddingLeft: '4px'
                        }}>
                            {
                                data.literalForm && data.literalForm[labelLang] ? data.literalForm[labelLang] : 'No label available'
                            }
                        </span>
                    </span>} />
            </Tooltip>
        );
    }
}

LabelLink.defaulProps = {
    compact: false
};

LabelLink.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    source: PropTypes.string,
    compact: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    target: PropTypes.string,
    isReadOnly: PropTypes.bool,
    graph: PropTypes.string,
    propertyGraph: PropTypes.string,
    link: PropTypes.string,
    onLink: PropTypes.func,
    property: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    updateEvent: PropTypes.func
};

export default withRouter(withStyles(styles)(withGS(LabelLink, ["ALL"], ["id", "iri", "literalForm", "status"], loadOptions)));